import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { Menu, MenuButton, MenuList, MenuItem, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const languages = [
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'th', name: 'ไทย', flag: '🇹🇭' }
];

const LanguageSwitcher = ({ isMobile = false }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const currentLang = languages.find(lang => lang.code === i18n.language) || languages[0];
  
  // 言語変更処理
  const changeLanguage = (langCode) => {
    // 現在のパスを取得
    const currentPath = window.location.pathname;
    
    // 言語部分を除いたパス
    let pathWithoutLang = currentPath;
    
    // 現在のパスが /ja/ /en/ /th/ で始まっているかチェック
    const langPathMatch = currentPath.match(/^\/(ja|en|th)(\/.*|$)/);
    if (langPathMatch) {
      // 言語部分を除いたパスを取得
      pathWithoutLang = langPathMatch[2] || '/';
    } else if (currentPath === '/') {
      // ルートパスの場合はそのまま
      pathWithoutLang = '/';
    }
    
    // 新しいパスを構築
    const newPath = langCode === 'ja' ? pathWithoutLang : `/${langCode}${pathWithoutLang === '/' ? '' : pathWithoutLang}`;
    
    // 言語設定を変更
    i18n.changeLanguage(langCode);
    
    // 新しいURLに遷移
    navigate(newPath);
  };

  if (isMobile) {
    // モバイル表示用シンプルな選択リスト
    return (
      <div className="py-2">
        <p className="text-sm text-gray-600 mb-2">言語 / Language / ภาษา</p>
        <div className="flex flex-col space-y-2">
          {languages.map((lang) => (
            <button
              key={lang.code}
              className={`flex items-center px-2 py-1 rounded ${i18n.language === lang.code ? 'bg-orange-100 text-orange-700' : ''}`}
              onClick={() => changeLanguage(lang.code)}
            >
              <span className="mr-2">{lang.flag}</span>
              <span>{lang.name}</span>
            </button>
          ))}
        </div>
      </div>
    );
  }

  // デスクトップ用のドロップダウン
  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        variant="ghost"
        size="sm"
        px={2}
      >
        <span className="mr-1">{currentLang.flag}</span>
        <span className="hidden sm:inline">{currentLang.name}</span>
      </MenuButton>
      <MenuList>
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={i18n.language === lang.code ? 'bg-orange-50' : ''}
          >
            <span className="mr-2">{lang.flag}</span>
            <span>{lang.name}</span>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default LanguageSwitcher;